import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMailArrowUpIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15 9.95399L8.978 12.86C8.67299 13.0072 8.33868 13.0837 8 13.0837C7.66132 13.0837 7.32701 13.0072 7.022 12.86L1 9.95399V13.5C1 13.8978 1.15804 14.2794 1.43934 14.5607C1.72064 14.842 2.10218 15 2.5 15H13.5C13.8978 15 14.2794 14.842 14.5607 14.5607C14.842 14.2794 15 13.8978 15 13.5V9.95399Z",
		fill: "currentColor",
		stroke: "none"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.25 5.99973V9.49973C7.25 9.91395 7.58579 10.2497 8 10.2497C8.41421 10.2497 8.75 9.91395 8.75 9.49973V5.99973H13.5C13.8978 5.99973 14.2792 6.15793 14.5605 6.43919C14.8418 6.72046 15 7.10196 15 7.49973V8.2927C14.9741 8.30198 14.9486 8.31289 14.9238 8.32493L8.32617 11.5095C8.12017 11.6095 7.87983 11.6095 7.67383 11.5095L1.07617 8.32493C1.05117 8.31293 1.026 8.3017 1 8.2927V7.49973C1.00004 7.10196 1.15818 6.72046 1.43945 6.43919C1.72075 6.15793 2.10221 5.99973 2.5 5.99973H7.25ZM7.46973 1.21946C7.7626 0.926663 8.2374 0.926663 8.53027 1.21946L11.0303 3.71946C11.3231 4.01233 11.3231 4.48711 11.0303 4.78001C10.7374 5.0729 10.2626 5.0729 9.96973 4.78001L8.75 3.56028V5.99973H7.25V3.56028L6.03027 4.78001C5.73738 5.0729 5.26262 5.0729 4.96973 4.78001C4.6769 4.48711 4.67686 4.01233 4.96973 3.71946L7.46973 1.21946Z",
		fill: "currentColor",
		stroke: "none"
	})]
});
export default SvgMailArrowUpIcon;
